import { render, staticRenderFns } from "./footer-faqs.vue?vue&type=template&id=394f61be&scoped=true"
import script from "./footer-faqs.vue?vue&type=script&lang=js"
export * from "./footer-faqs.vue?vue&type=script&lang=js"
import style0 from "./footer-faqs.vue?vue&type=style&index=0&id=394f61be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394f61be",
  null
  
)

export default component.exports